document.addEventListener('DOMContentLoaded', () => {
    const privacyPolicy = document.querySelector('.cky-consent-container .cky-policy');

    if (privacyPolicy) {
        privacyPolicy.setAttribute('target', '_self');
    }
})
